'use client'

import { memo } from 'react'

import { ExternalIcon } from '@components/Layout/NavLink'
import { Button, type ButtonProps } from '@fp/ui-kit'

interface CustomActionButtonProps {
  label: string
  icon?: React.ReactNode
  variant?: ButtonProps['variant']
  size?: ButtonProps['size']
  external?: boolean
  onClick: () => void
  className?: string
}

export const CustomActionButton = memo<CustomActionButtonProps>(
  ({ label, icon, variant = 'default', size = 'sm', external, onClick, className }) => (
    <Button variant={variant} size={size} onClick={onClick} className={className}>
      {icon}
      {label}
      {external && <ExternalIcon />}
    </Button>
  ),
)

CustomActionButton.displayName = 'CustomActionButton'
